import UserDetail from './userDetailReducer';
import UserProfile from '../components/userProfile/reducer';
import ProtocolBuilder from '../components/protocolBuilder/reducer';

export default {
  UserDetail,
  UserProfile,
  ProtocolBuilder,
};
